import { BaseFactory } from './BaseFactory';
import { V1 as ClientV1 } from '../Models/Clients/V1';

export class Clients extends BaseFactory
{
	public getV1(host=null, port=null, ssl=true)
	{
		var rObj		= new ClientV1();
		rObj.setService(this.getService());
		rObj.setConfig(host, port, ssl);
		rObj.setExceptionCb(this.getService().getLogging(), "exception");
		return rObj;
	}
}